import React, { useState, useEffect } from 'react';
import CommonInput from '../../Common/CommonInput';

import { fetchSettings } from '../../../store/modules/profile/profileActions';
import useFormSettings from '../../../hooks/useFormSettings';

const ProfileForm = ({ initialData, onSave, isLoading, onClose }) => {
    const { settings, isLoadingSettings, isSettingsInitialized } = useFormSettings('profile', fetchSettings);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
    });
    
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (initialData) {
            setFormData({
                ...initialData,
                name: initialData.name || '',
                email: initialData.email || '',
                phone: initialData.phone || '',
                password: initialData.password || '',
                password_confirmation: initialData.password_confirmation || '',
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        if (errors[name]) {
            setErrors(prev => ({...prev, [name]: ''}));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsSaving(true);
            await onSave(formData);
            setErrors({});
            onClose();
        } catch (error) {
            if (error.errors) {
                const newErrors = {};
                Object.keys(error.errors).forEach(key => {
                    newErrors[key] = Array.isArray(error.errors[key]) 
                        ? error.errors[key][0] 
                        : error.errors[key];
                });
                setErrors(newErrors);
            } else {
                setErrors({
                    name: error.message || 'An error occurred while saving'
                });
            }
            return;
        } finally {
            setIsSaving(false);
        }
    };

    const isSubmitting = isLoading || isSaving;

    if (isLoadingSettings || !isSettingsInitialized) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="h-100 d-flex flex-column">
            <div className="d-flex justify-content-between mb-2">
                <div className="d-flex justify-content-start">
                    <h5 className="mb-2">Update Profile</h5>
                </div>
                <div className="d-flex justify-content-end">
                </div>
            </div>

            <div className="flex-grow-1">



                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-12">
                                <CommonInput
                                    label="Full Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={true}
                                    disabled={isSubmitting}
                                />
                            </div>
                            <div className="col-md-12">
                                <CommonInput
                                    label="Email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={true}
                                    disabled={isSubmitting}
                                />
                            </div>
                            <div className="col-md-12">
                                <CommonInput
                                    label="Phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={true}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-12">
                                <CommonInput
                                    label="Password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={false}
                                    disabled={isSubmitting}
                                />
                            </div>
                            <div className="col-md-12">
                                <CommonInput
                                    label="Confirm Password"
                                    name="password_confirmation"
                                    value={formData.password_confirmation}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={false}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="form-footer">
                <button 
                    type="button" 
                    className="btn btn-light" 
                    onClick={onClose}
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <button 
                    type="submit" 
                    className="btn btn-primary" 
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Saving...
                        </>
                    ) : 'Save'}
                </button>
            </div>
        </form>
    );
};

export default ProfileForm; 